export enum EInsightsTab {
  customer = 'customer',
  fleet = 'fleet',
}

export const INSIGHTS_ACTIVE_TAB_KEY = 'insights-active-tab';

export const insightsTabs = [
  { key: EInsightsTab.customer, label: 'Customer Insights' },
  { key: EInsightsTab.fleet, label: 'Fleet Insights' },
];
